import { graphql } from "@/gql"
import { SkillsFilterItemFragment } from "@/gql/graphql"
import { useEffect } from "react"
import { create } from "zustand"

graphql(`
  query GetAllLanguages($first: Int, $after: String) {
    allLanguages(first: $first, after: $after) {
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        ...LanguagesFilterItem
      }
    }
  }
`)

graphql(`
  fragment LanguagesFilterItem on LanguageEdge {
    node {
      id
      name
    }
  }
`)

interface CreativeWorkTypesStore {
  languages: (SkillsFilterItemFragment | null)[]
  setLanguages: (languages: (SkillsFilterItemFragment | null)[]) => void
}

const useLanguagesFilterStore = create<CreativeWorkTypesStore>(set => ({
  languages: [],
  setLanguages: languages => set({ languages }),
}))

export const useLanguagesFilter = (orderBy: "name" | "popularity" = "name") => {
  const { languages, setLanguages } = useLanguagesFilterStore()

  useEffect(() => {
    const fetchLanguages = async () => {
      const res = await fetch("/api/filters/languages")
      const data: { allLanguages: (SkillsFilterItemFragment | null)[] } = await res.json()
      setLanguages(data?.allLanguages)
    }

    fetchLanguages()
  }, [setLanguages])

  return languages
}
